import { map } from 'rxjs/operators';
import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { InspectionFolder } from '../models/index';
import { DataService } from './data.service';
import { ApiService } from './api.service';
import { InspectionFactoryService } from './inspectionFactory.service';
import { ActionPlanDataService } from './action-plan-data.service';
import { BaseService } from './baseService';

@Injectable({
  providedIn: 'root'
})
export class InspectionFolderService extends BaseService {
  private baseUrl = '/inspections/';

  constructor(
    private apiService: ApiService,
    private dataService: DataService,
    private factory: InspectionFactoryService
  ) {
    super();
  }

  public setBaseUrl(newBaseUrl: string) {
    this.baseUrl = newBaseUrl;
  }

  public createFolder(id: string, sectionId: string, model: any) {
    return this._createFolder(id, sectionId, model).pipe(
      map((folder: InspectionFolder) => {
        return this.dataService.updateFolder(id, sectionId, folder);
      })
    );
  }

  public deleteFolders(id: string, sectionId: string, folderIds: string[]): Observable<any> {
    return this._deleteFolders(id, sectionId, folderIds).pipe(
      map((res: any) => {
        if (res.deletedPoints) {
          res.deletedPoints.forEach((pointId) => this.dataService.removePoint(id, pointId));
        }
        if (res.deletedFolders) {
          this.dataService.removeFolder(id, sectionId, res.deletedFolders);
        }
        const inspection = this.dataService.getInspection(id);
        inspection.progression = res.inspectionProgression;
        this.dataService.removeParts(id, res.deletedPoints);
        return res.deletedPoints;
      })
    );
  }

  public getFolder(inspectionId: string, folderId: string): Observable<InspectionFolder> {
    return this.dataService.getFolder(inspectionId, folderId);
  }

  public updateProperties(id: string, sectionId: string, folderId: string, params: any): Observable<InspectionFolder> {
    return this._updateProperties(id, sectionId, folderId, params).pipe(
      map((folder: InspectionFolder) => {
        return folder;
      })
    );
  }

  private _createFolder(id: string, sectionId: string, model: any) {
    const url = `${this.baseUrl}${id}/sections/${sectionId}/folders/new`;

    if (this.isInspectionInOffline(id)) {
      return this.factory.createFolder(id, sectionId, model);
    }
    return this.apiService.post(url, model);
  }

  private _deleteFolders(id: string, sectionId: string, folderIds: string[]): any {
    const url = `${this.baseUrl}${id}/sections/${sectionId}/folders/delete`;
    if (this.isInspectionInOffline(id)) {
      return this.factory.deleteFolders(id, sectionId, folderIds);
    }
    return this.apiService.post(url, folderIds);
  }

  private _updateProperties(id: string, sectionId: string, folderId: string, params: any): Observable<any> {
    const url = `${this.baseUrl}${id}/sections/${sectionId}/folders/${folderId}`;
    if (this.isInspectionInOffline(id)) {
      return this.factory.updateFolder(id, sectionId, folderId, params);
    }
    return this.apiService.patch(url, params);
  }
}
